pageId = 'page-project_groups-index'
page = '#' + pageId

$(document).on 'pjaxload#' + pageId, (e, $page, page) ->
  $('.project-groups-list').sortable
    handle: '.group-link'
    scrollSensitivity: 20
    cursor: 'move'
    distance: 5
    helper: 'clone'
    items: '.group'
    placeholder: 'group-placeholder'
    tolerance: 'pointer'
    update: (e, ui) ->
      $group = ui.item
      $.ajax
        url: $group.find('.group-link').data('order-url')
        type: 'put'
        data:
          project_group:
            display_order_position: $group.index()
        success: ->
          tower.highlight $group
          return false
